import React, { Fragment, useState, useEffect } from 'react';
import loader from '../../assets/images/1487.gif';

import './Loader.module.scss';

const Loader = (props) => {

  const [show, setShow] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(false)
    }, 3000);

    return () => {
      clearTimeout(timeout);
    }

  }, [show]);

  return (
    <Fragment>
      <div className={`loader-wrapper ${show ? '' : 'loderhide'}`}>
        <div id="global-loader1">
          <img src={loader} className="loader-img" alt="Loading...." />
        </div>
      </div>
    </Fragment>
  );
}

export default Loader;